export default __webpack_public_path__ + "static/media/workouttimes_7@2x.eef0983b.jpg";